import { c as _c } from "react/compiler-runtime";
import { clsx } from 'clsx';
import styles from './Stack.module.css';
import type { StackProps } from './Stack.types';
const Stack = t0 => {
  const $ = _c(9);
  const {
    children,
    space,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "vertical" : t1;
  const t2 = `var(${space})`;
  let t3;
  if ($[0] !== t2) {
    t3 = {
      "--stack-space": t2
    };
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const spacingToken = t3 as React.CSSProperties;
  const t4 = variant === "horizontal";
  const t5 = variant === "vertical";
  let t6;
  if ($[2] !== t4 || $[3] !== t5) {
    t6 = clsx({
      [styles.horizontal]: t4,
      [styles.vertical]: t5
    });
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const classNames = t6;
  let t7;
  if ($[5] !== children || $[6] !== classNames || $[7] !== spacingToken) {
    t7 = <div className={classNames} style={spacingToken} data-test-id="Stack">{children}</div>;
    $[5] = children;
    $[6] = classNames;
    $[7] = spacingToken;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
};
export { Stack };